import { llamar } from "./planillaMovimientos";

/* Dónde está cada tractor y dónde pasó la noche (Lautaro, 19/10), para el
 * botón «Actualizar ubicación y pernocte» de Torrecillas.
 *
 * Las posiciones viven en FlotaBot (la foto en vivo de CAR TRUCK y Michelin,
 * y el historial de cada 10 minutos), así que va por el puente SSO de
 * siempre a /api/satelital/pernoctes, que SÓLO lee. Lo que se escribe es su
 * planilla, desde el hub, cuando él aprieta.
 *
 * `unidades` son las claves de TRA (`claveDeTra`); `fecha`, AAAA-MM-DD: la
 * mañana del pernocte. */

const NO_PUEDO = "No podés pasar.";

export function traerUbicacionYPernocte(unidades, fecha) {
  const fd = new FormData();
  fd.append("fecha", fecha);
  fd.append("unidades", JSON.stringify(unidades));
  return llamar("/api/satelital/pernoctes", fd, NO_PUEDO);
}
